import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { ErrorResponse } from "../../models/apiResponse";
import { CorporateService } from "../../models/Service";

const useQueryService = ({
  corporateId,
  enabled = true,
  authorisation = "",
  retry,
}: {
  corporateId: string;
  enabled?: boolean;
  authorisation?: string;
  // Left unset, the client's own default applies. A caller that has a
  // fallback for a failed read sets it to false rather than wait the
  // retries out behind a spinner.
  retry?: boolean;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/corporate-service`],
    () =>
      httpClient(`corporate-subsidiary/${corporateId}/corporate-service`, {
        authorisation,
      }).get<CorporateService[] | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
      ...(retry === undefined ? {} : { retry }),
    }
  );
};

export const useQueryServiceByServiceId = ({
  corporateId,
  serviceId,
  enabled = true,
  authorisation = "",
}: {
  corporateId: string;
  serviceId: string;
  enabled?: boolean;
  authorisation?: string;
}) => {
  return useQuery(
    [`/corporate-subsidiary/${corporateId}/corporate-service/${serviceId}`],
    () =>
      httpClient(
        `corporate-subsidiary/${corporateId}/corporate-service/${serviceId}`,
        { authorisation }
      ).get<CorporateService | ErrorResponse>(),
    {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      enabled,
    }
  );
};

export default useQueryService;
